import {
  CREATE_QUIZ_SESSION,
} from '../types';


export function createQuizSession(payload) {
  return {
    type: CREATE_QUIZ_SESSION,
    payload,
  };
}
